import Vue from "vue";
import Vuex from "vuex";
import User from "static/js/user";
Vue.use(Vuex);

const state = {
  //要设置的全局访问的state对象，初始属性值
  account: sessionStorage.getItem("account"), //当前账户地址
  chainNameList: JSON.parse(sessionStorage.getItem("chainNameList")),
  selectedChain: "", // 链全称
  chainList: JSON.parse(sessionStorage.getItem("chainList")),
  currentChain: "eth", // 链简称
  routerList: JSON.parse(sessionStorage.getItem("routerList")),
  chainInfo: {},
  legalCoin: {
    alias: "USD",
    name: "美元",
    point: "4",
    rmb: "6.3652",
    symbol: "$",
  },
  coins: [],
  unit: "USD",
  tokensInfoList: [],
  coinsInfo: [],
};
const getters = {
  //实时监听state值的变化(最新状态)
  account(state) {
    return state.account;
  },
  currentChain(state) {
    return state.currentChain;
  },
  chainList(state) {
    return state.chainList;
  },
  chainNameList(state) {
    return state.chainNameList;
  },
  selectedChain(state) {
    return state.selectedChain;
  },
  chainInfo(state) {
    return state.chainList[state.currentChain];
  },
  routerList(state) {
    return state.routerList;
  },
  legalCoin(state) {
    return state.legalCoin;
  },
  coins(state) {
    return state.coins;
  },
  unit(state) {
    return state.unit;
  },
  tokensInfoList(state) {
    return state.tokensInfoList;
  },
  coinsInfo(state) {
    return state.coinsInfo;
  },
};
const mutations = {
  setAccount(state, val) {
    state.account = val;
    if (val) {
      sessionStorage.setItem("account", val);
    } else {
      sessionStorage.removeItem("account");
    }
  },
  setCurrentChain(state, val) {
    state.currentChain = val;
    sessionStorage.setItem("currentChain", val);
    state.chainInfo = state.chainList[val];
    state.selectedChain = state.chainNameList[val];
    state.tokensInfoList = [];
    if (val) {
      this.commit("setUser", { chain: val });
    }
  },
  setUser(state, chain) {
    if (chain.rpc) {
      state.chainList[chain.chain].ws = new User(chain.rpc);
    } else {
      state.chainList[chain.chain].ws = new User(
        state.chainList[chain.chain].rpc
      );
    }
  },
  setLegalCoin(state, val) {
    state.legalCoin = val;
  },
  setCoins(state, val) {
    state.coins = val;
  },
  setUnit(state, val) {
    state.unit = val;
  },
  setTokensInfoList(state, val) {
    state.tokensInfoList = val;
  },
  setCoinsInfo(state, val) {
    state.coinsInfo = val;
  },
};
const actions = {
  setAccount(context, val) {
    context.commit("setAccount", val);
  },
  setCurrentChain(context, val) {
    context.commit("setCurrentChain", val);
  },
  setUser(context, val) {
    context.commit("setUser", val);
  },
  setLegalCoin(context, val) {
    context.commit("setLegalCoin", val);
  },
  setCoins(context, val) {
    context.commit("setCoins", val);
  },
  setUnit(context, val) {
    context.commit("setUnit", val);
  },
  setTokensInfoList(context, val) {
    context.commit("setTokensInfoList", val);
  },
  setCoinsInfo(context, val) {
    context.commit("setCoinsInfo", val);
  },
};
export default new Vuex.Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
});
